import { Link, useNavigate } from "react-router-dom";
import { server } from "../server";
import { useState } from "react";

function Signup() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "123",
    phone: "",
    address: "",
    category: "Individual",
    organization: "",
    businessName: "",
    platform: "web",
    deviceToken: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${server}/Auth/Signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        navigate("/verify-otp", { state: { phone: formData.phone } });
      } else {
        alert(data.message || "Signup failed");
      }
    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleNext = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone) {
      alert("Please fill all required fields.");
      return;
    }

    if (formData.category === "Company" && !formData.businessName.trim()) {
      alert("Please enter Company Name.");
      return;
    }

    setStep(2);
  };

  return (
    <>
      <section className="bg-signup vh-100 d-flex align-items-center">
        <div className="container position-relative z-3">
          <div className="row g-0 login-bg vh-85 rounded-5 overflow-hidden">
            <div className="col-lg-4 col-md-12 d-flex align-items-center justify-content-center">
              <form
                className="col-12"
                onSubmit={step === 2 ? handleSubmit : handleNext}
              >
                <div className="ps-7 pe-8 mt-n3 m-2 w-100 pt-lg-0 pt-8 mb-0">
                  <div>
                    <Link to="/">
                      <img
                        src="/assets/images/logo.png"
                        className="mb-3"
                        alt="logo-icon"
                        width="130"
                      />
                    </Link>
                    <div className="d-flex flex-column gap-1">
                      <h3 className="mb-0 fw-bold text-white lh-1">Sign Up</h3>
                      <span className="text-light lh-1">
                        Already have an account?
                        <Link to="/login" className="ms-1">
                          Login
                        </Link>
                      </span>
                    </div>

                    <div className="mt-4">
                      {step === 1 && (
                        <>
                          <div className="row g-1 mb-3">
                            <div className="col-6">
                              <button
                                type="button"
                                className={`badge border-0 py-3 w-100 rounded-3 ${
                                  formData.category === "Individual"
                                    ? "bg-info-soft"
                                    : "bg-white-soft"
                                }`}
                                onClick={() =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    category: "Individual",
                                    businessName: "",
                                  }))
                                }
                              >
                                Individual
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                type="button"
                                className={`badge border-0 py-3 w-100 rounded-3 ${
                                  formData.category === "Company"
                                    ? "bg-info-soft"
                                    : "bg-white-soft"
                                }`}
                                onClick={() =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    category: "Company",
                                  }))
                                }
                              >
                                Company
                              </button>
                            </div>
                          </div>

                          <div className="mb-2">
                            <label className="label-text text-light opacity-75 mb-1 ms-3">
                              Full Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              className="form-control ps-3 normal-text text-white bg-transparent light-border rounded-3"
                              placeholder="Enter Full Name"
                              required
                            />
                          </div>

                          {formData.category === "Company" && (
                            <div className="mb-2">
                              <label className="label-text text-light opacity-75 mb-1 ms-3">
                                Company Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="businessName"
                                value={formData.businessName}
                                onChange={handleChange}
                                className="form-control ps-3 normal-text text-white bg-transparent light-border rounded-3"
                                placeholder="Enter Company Name"
                                required
                              />
                            </div>
                          )}

                          <div className="mb-4">
                            <label className="label-text text-light opacity-75 mb-1 ms-3">
                              Phone No <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              className="form-control ps-3 normal-text text-white bg-transparent light-border rounded-3"
                              placeholder="Enter Phone No"
                              required
                            />
                          </div>

                          <button
                            type="submit"
                            className="btn btn-gradient-bg-2 border-0 text-white rounded-3 px-6 btn-md w-100"
                          >
                            Continue
                          </button>
                        </>
                      )}

                      {step === 2 && (
                        <>
                          <div className="mb-2">
                            <label className="label-text text-light opacity-75 mb-1 ms-3">
                              Email ID <span className="text-danger">*</span>
                            </label>
                            <input
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              className="form-control ps-3 normal-text text-white bg-transparent light-border rounded-3"
                              placeholder="Enter Email ID"
                              required
                            />
                          </div>

                          <div className="mb-4">
                            <label className="label-text text-light opacity-75 mb-1 ms-3">
                              Address <span className="text-danger">*</span>
                            </label>
                            <textarea
                              name="address"
                              value={formData.address}
                              onChange={handleChange}
                              rows="4"
                              className="form-control ps-3 normal-text text-white bg-transparent light-border rounded-3"
                              placeholder="Enter Address"
                              required
                            ></textarea>
                          </div>

                          <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-gradient-bg-2 border-0 text-white rounded-3 px-6 btn-md w-100"
                          >
                            {loading ? (
                              <div
                                className="spinner-border spinner-border-sm"
                                role="status"
                              ></div>
                            ) : (
                              "Register Now"
                            )}
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="mt-3 text-center">
                    <Link to="/contact" className="fs-5 lh-1">
                      Need Help ? Contact Us
                    </Link>
                  </div>
                </div>
              </form>
            </div>

            <div className="col-lg-8 col-md-12">
              <img
                src="/assets/images/3.jpg"
                className="w-100 h-100 object-fit-cover rounded-end-5"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Signup;
